import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
// import Pricing from './components/Pricing';
import ProductShowcase from './components/Testimonials';
import AgentShowcase from './components/AgentShowcase';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <ProductShowcase />
        <AgentShowcase />
        {/* <Pricing /> */}
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App; 